/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  Button,
  SvgIcon
} from "../"

// Toast serves as a feedback & confirmation mechanism after the user takes an action.
export const Toast = (props) => (
  <div className="slds-notify_container slds-is-relative">
    <div className={`slds-notify slds-notify_toast slds-theme_${props.type}`} role="alert">
      <span className="slds-assistive-text">{props.type}</span>
        {props.noTypeIcon
          ? <span></span>
          : <span
              className="slds-icon_container slds-m-right_small slds-no-flex slds-align-top"
              title="Description of icon when needed">
              <SvgIcon
                variant="utility"
                symbol={props.type}
                size="x-small"
                colour="inverse"
              />
            </span>
        }
      <div className="slds-notify__content">
        <h2 className="slds-text-heading_small">
          {/* TODO: use NavLink instead of href..? */}
          {props.feedback} <a href={props.actionLink}>{props.actionText}</a>
        </h2>
      </div>
      <Button
        type="reset"
        className="slds-button_icon slds-notify__close"
        title="Close">
        <SvgIcon
          variant="utility"
          symbol="close"
          size="small"
          colour="inverse"
        />
        <span className="slds-assistive-text">Close</span>
      </Button>
    </div>
  </div>
)

Toast.defaultProps = {
  type: "info"
}

Toast.propTypes = {
  feedback: PropTypes.string.isRequired,
  actionText: PropTypes.string,
  actionLink: PropTypes.string,
  type: PropTypes.oneOf(["info", "success", "warning", "error"]),
  noTypeIcon: PropTypes.bool,
  className: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/toast/index.js